import { gql } from 'apollo-angular';

export const GET_POLICIES = gql`
  query GetPolicies {
    shop {
      privacyPolicy {
          body
          id
          title
          url
      }
      refundPolicy {
          body
          id
          title
          url
      }
      shippingPolicy {
          body
          id
          title
          url
      }
      termsOfService {
          body
          id
          title
          url
      }
    }
  }
`;

